export default __webpack_public_path__ + "static/media/halo_logo_256.505b9498.png";